export default "__VITE_ASSET__QgnwkDMK__"